export const SET_SMS = 'SET_SMS';
export const RESEND_SMS_MODAL_ID = 'RESEND_SMS_MODAL_ID';


// WEBPACK FOOTER //
// ./src/store/modules/sms-tracking/mutations.js